import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const Hero = () => {
  return (
    <section className="bg-cream px-6 py-16 md:py-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="order-2 lg:order-1"
        >
          <span className="text-brass text-xs font-bold tracking-[0.2em] uppercase mb-5 block">
            Maryland · Notary Public · Apostille
          </span>

          <h1 className="font-fraunces text-5xl md:text-6xl lg:text-7xl leading-[1.08] text-navy mb-7">
            Maryland Mobile and Online Notary Services
          </h1>

          <p className="text-lg md:text-xl text-navy/70 max-w-xl leading-relaxed mb-10">
            Bilingual notary services across Prince George&apos;s and Montgomery
            County. Evenings and weekends, in English and Português.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <a
              href="/contact"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-navy text-cream px-10 py-4 rounded-full text-base font-bold hover:bg-brass transition-colors shadow-lg group"
            >
              Book Your Appointment
              <SafeIcon
                icon={FiArrowRight}
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a
              href="tel:2405713117"
              className="w-full sm:w-auto inline-flex items-center justify-center border border-navy text-navy px-10 py-4 rounded-full text-base font-bold hover:bg-navy hover:text-cream transition-all"
            >
              Call or Text (240) 571-3117
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.1 }}
          className="order-1 lg:order-2 relative max-w-md lg:max-w-none mx-auto w-full"
        >
          <div className="absolute -inset-4 bg-brass/10 blur-2xl rounded-full opacity-70" />
          <div className="relative bg-cream-light border-[12px] border-navy shadow-2xl rounded-t-[11rem] rounded-b-[2rem] overflow-hidden aspect-[4/5]">
            <img
              src="https://media-manager-c.questera.ai/greta-media/4320f8aaa9ed428bff142ca67321b3bfce2c39771503d4270b0b625b52f5e6960d1f85712829807a2ee1ac58fcf9446b/images/aW1hZ2UvanBlZw==/bb8151bdd9359275e0a1e936fd80ec25.jpg"
              alt="Carlos reviewing and signing a document"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;